(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["options-select"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  let lastOpenedVariant = null;
  let isOpening = false;

  document.querySelectorAll(".custom-dropdown").forEach(function (dropdown) {
    const selected = dropdown.querySelector(".custom-dropdown-selected");
    const selectedText = selected.querySelector(".selected-text");
    const list = dropdown.querySelector(".custom-dropdown-list");
    const selectId = dropdown.dataset.selectId;
    const select = document.getElementById(selectId);

    // Toggle dropdown
    selected.addEventListener("click", function () {
      list.style.display = list.style.display === "block" ? "none" : "block";
      selected.classList.toggle("open");
    });

    // Select option
    list.querySelectorAll("li").forEach(function (item) {
      item.addEventListener("click", function () {
        const value = this.getAttribute("data-value");
        selectedText.textContent = value;
        select.value = value;
        select.dispatchEvent(new Event("change", { bubbles: true }));

        // Close dropdown
        list.style.display = "none";
        selected.classList.remove("open");

        // Mark selected item
        list.querySelectorAll("li").forEach(li => li.classList.remove("selected"));
        this.classList.add("selected");

        // ✅ Only open BIS if variant is out-of-stock
        const option = select.querySelector(`option[value="${value}"]`);
        const available = option ? option.dataset.variantOptionAvailable : "false";

        if (available !== "true") {
          const bisBtn = this.querySelector(".klaviyo-bis-trigger");
          if (bisBtn && lastOpenedVariant !== value && !isOpening) {
            isOpening = true;
            lastOpenedVariant = value;

            // Close any existing popup
            const closeBtn = document.querySelector(".klaviyo-close-form");
            if (closeBtn) closeBtn.click();

            setTimeout(() => {
              bisBtn.click();
              setTimeout(() => {
                isOpening = false;
              }, 1000);
            }, 200);
          }
        }
      });
    });

    // Close dropdown on outside click
    document.addEventListener("click", function (e) {
      if (!dropdown.contains(e.target)) {
        list.style.display = "none";
        selected.classList.remove("open");
      }
    });

    // ✅ Sync li classes + BIS button placement with <select> availability
    function updateOutOfStockClasses() {
      if (select && list) {
        list.querySelectorAll("li").forEach(li => {
          const value = li.getAttribute("data-value");
          const option = select.querySelector(`option[value="${value}"]`);
          const available = option ? option.dataset.variantOptionAvailable : "false";

          // --- In Stock ---
          if (available === "true") {
            li.classList.remove("out-of-stock");
            // remove BIS button if present
            li.querySelectorAll(".klaviyo-bis-trigger").forEach(btn => btn.remove());
          } 
          // --- Out of Stock ---
          else {
            li.classList.add("out-of-stock");
            // add BIS button if missing
            if (!li.querySelector(".klaviyo-bis-trigger")) {
              const bisBtn = document.querySelector(".klaviyo-bis-trigger.original-bis-btn");
              if (bisBtn) {
                const clonedBtn = bisBtn.cloneNode(true);
                clonedBtn.classList.add("cloned");
                clonedBtn.style.display = "inline"; // ✅ force visible
                li.appendChild(clonedBtn);
              }
            } else {
              // ensure BIS button is visible
              li.querySelectorAll(".klaviyo-bis-trigger").forEach(btn => {
                btn.style.display = "inline";
              });
            }
          }
        });
      }
    }

    // Watch for Klaviyo BIS button injection
    const observer = new MutationObserver(function () {
      const bisBtn = document.querySelector(".klaviyo-bis-trigger");
      if (bisBtn && !bisBtn.classList.contains("original-bis-btn")) {
        bisBtn.classList.add("original-bis-btn");
        updateOutOfStockClasses();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Run once on load
    updateOutOfStockClasses();
  });
});
  } catch(e) { console.error(e); }
})();

})();
